/**
 * @file: mileageRange.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { Range } from '@euler/model/common';
import { AbstractSearchCriterionProvider } from '../AbstractSearchCriterionProvider';
import { SearchCriterionOption } from '../types';

const PredefinedRanges: [number | undefined, number | undefined][] = [
  [undefined, 5000],
  [undefined, 10000],
  [undefined, 20000],
  [undefined, 30000],
  [undefined, 40000],
  [undefined, 50000],
  [undefined, 60000],
  [undefined, 70000],
  [undefined, 80000],
  [undefined, 90000],
  [undefined, 100000],
  [undefined, 150000],
  [undefined, 200000],
  [5000, 10000],
  [10000, 20000],
  [20000, 30000],
  [30000, 40000],
  [40000, 50000],
  [50000, 60000],
  [60000, 70000],
  [70000, 80000],
  [80000, 90000],
  [90000, 100000],
  [100000, 150000],
  [150000, 200000],
  [10000, undefined],
  [20000, undefined],
  [30000, undefined],
  [40000, undefined],
  [50000, undefined],
  [60000, undefined],
  [70000, undefined],
  [80000, undefined],
  [90000, undefined],
  [100000, undefined],
  [150000, undefined],
  [200000, undefined],
];

export class MileageRangeCriterion extends AbstractSearchCriterionProvider<'mileageRange'> {
  static readonly shared = new MileageRangeCriterion();

  constructor() {
    super('mileageRange');
  }

  getLabel(): string {
    return '进店里程';
  }

  internalGetDisplayText(range: Range<number>): string {
    if (range?.start != null || range?.end != null) {
      const { start, end } = range;
      if (start != null && end != null) {
        return `${start}-${end}公里`;
      } else if (start != null) {
        return `${start}公里以上`;
      } else if (end != null) {
        return `${end}公里以下`;
      }
    }
    return '全部';
  }

  internalGetOptions(): SearchCriterionOption<Range<number>>[] {
    return PredefinedRanges.map(([start, end]) => ({
      value: { start, startInclusive: true, end, endInclusive: true },
    }));
  }

  protected internalGetKey(value: Range<number>): string {
    const { start, end } = value;
    if (start != null && end != null) {
      return `${start}-${end}`;
    } else if (start != null) {
      return `>=${start}`;
    } else if (end != null) {
      return `<=${end}`;
    }
    return '';
  }
}
